import React from 'react';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import {makeStyles} from '@mui/styles';
import {theme} from '../../Theme';

interface IProps {
  ref?: any;
  id?: any;
  name?: string;
  label?: string;
  placeholder?: string;
  type?: string;
  value?: any;
  defaultValue?: any;
  disabled?: boolean;
  hidden?: boolean;
  autocomplete?: boolean;
  multiline?: boolean;
  rows?: number;
  maxRows?: number;
  fullWidth?: boolean;
  gutterBottom?: boolean;
  inverted?: boolean;
  autoFocus?: boolean;
  helperText?: any;
  style?: any;
  InputProps?: any;
  inputProps?: any;
  InputLabelProps?: any;
  onChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  onFocus?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  onBlur?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  onKeyUp?: React.KeyboardEventHandler<HTMLDivElement>;
  onKeyDown?: React.KeyboardEventHandler<HTMLDivElement>;
  homeDepot?: boolean;
}

const useStyles = (props: IProps) =>
  makeStyles(() => ({
    roundedInput: {
      '& .MuiFilledInput-root': {
        height: props.multiline ? 'auto' : 42,
        padding: 0,
        borderRadius: 22,
        border: props.helperText
          ? `1px solid ${theme.palette.red.main}`
          : props.inverted
            ? `1px solid ${theme.palette.gray.medium}`
            : `1px solid ${theme.palette.gray.main}`,
        backgroundColor: props.helperText
          ? theme.palette.red.light
          : props.inverted
            ? theme.palette.secondary.main
            : theme.palette.gray.main,
        opacity: props.disabled ? '75%' : '100%',

        '&:focus-within': {
          border: `1px solid ${theme.palette.blue.main}`,
        },
        '&:hover': {
          border: !props.disabled
            ? `1px solid ${theme.palette.primary.light}`
            : `1px solid ${theme.palette.gray.main}`,
        },
        '&:before': {
          borderBottom: 'none !important',
        },
        '&:after': {
          borderBottom: 'none !important',
        },

        '& .MuiFilledInput-input': {
          height: props.type === 'date' ? 20 : 'auto',
          padding:
            props.multiline || props.autocomplete ? '0px 12px' : '9px 12px',
          fontSize: 14,
          fontFamily: 'AeonikProReqular, sans-serif',
        },
      },

      '& .MuiInputBase-multiline': {
        paddingTop: 12,
      },

      '& .MuiInputAdornment-root': {
        marginTop: '0px !important',
      },

      '& .MuiInputBase-root.Mui-disabled': {
        color: 'rgba(0,0,0,0.54)',
      },
    },

    homeDepotInput: {
      '& .MuiOutlinedInput-root': {
        color: '#333',
        height: props.multiline ? 'auto' : 42,
        borderRadius: 2,
        border: props.helperText ? '1px solid #d40003' : '1px solid #666',
      },
    },
  }));

export default function BidmiiTextField(props: IProps) {
  const classes = useStyles(props)();

  return (
    <div>
      {props.label && (
        <Typography
          variant="subtitle2"
          align="left"
          style={{
            fontSize: 14,
            fontWeight: 400,
            lineHeight: 1.3,
            marginBottom: 4,
            color: props.disabled
              ? theme.palette.gray.dark
              : theme.palette.primary.light,
          }}>
          {props.label}
        </Typography>
      )}
      <TextField
        variant={props.homeDepot ? 'outlined' : 'filled'}
        ref={props.ref}
        id={props.id}
        name={props.name}
        type={props.type}
        fullWidth={props.fullWidth}
        multiline={props.multiline}
        minRows={props.rows}
        maxRows={props.maxRows}
        placeholder={props.placeholder}
        value={props.value}
        defaultValue={props.defaultValue}
        disabled={props.disabled}
        hidden={props.hidden}
        autoFocus={props.autoFocus}
        helperText={props.helperText || undefined}
        FormHelperTextProps={{
          style: {
            color: theme.palette.red.dark,
            marginBottom: 12,
          },
        }}
        className={
          props.homeDepot ? classes.homeDepotInput : classes.roundedInput
        }
        style={{
          ...props.style,
          height: props.multiline ? 'auto' : 40,
          marginBottom: props.gutterBottom ? 16 : 0,
        }}
        InputProps={props.InputProps}
        inputProps={props.inputProps}
        InputLabelProps={props.InputLabelProps}
        onChange={props.onChange}
        onBlur={props.onBlur}
        onKeyUp={props.onKeyUp}
        onKeyDown={props.onKeyDown}
      />
    </div>
  );
}
